import AssignmentIcon from '@material-ui/icons/Assignment';
import React from 'react';

import { useDialogState } from '../dialog/useDialogState';
import { canCreateTask } from '../permissions';
import { NewPlexLevelEntityButton } from './NewPlexLevelEntityButton';

interface Props {
  className?: string;
}

export const NewTaskButton = React.memo(function NewQuestionButton({ className }: Props): React.ReactElement {
  const [, setDialogState] = useDialogState();

  return (
    <NewPlexLevelEntityButton
      className={className}
      label="Create Task"
      MuiIconRight={AssignmentIcon}
      canPerformAction={canCreateTask}
      onClick={({ plexId }): void => {
        setDialogState({ type: 'new_task', plexId });
      }}
    />
  );
});
